module.exports = __webpack_public_path__ + "img/germany-stomach-cancer-male.08118819.png";